import React from "react"
import GroupGameViewStyle from "./GroupGameView.module.css"
import GroupGameViewMentorPlayerSelectorTile from "./GroupGameViewMentorPlayerSelectorTile";


export default function GroupGameViewMentorPlayerSelector(props) {



    return <div className={GroupGameViewStyle.playerSelectorContainer}>
        {props.players.map((player) => <GroupGameViewMentorPlayerSelectorTile key={player.id} player={player} selectedPlayer={props.selectedPlayer} setSelectedPlayer={props.setSelectedPlayer}/>)}
    </div>
}